<template>

<v-content>
<v-container class="my-12">
<v-row>
      <v-col
        cols="12"
      >
  <v-card class="pa-4"  elevation="6" style="width:100%">
          <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                         Annotated Corpus
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <div class="text-center px-9 py-4">
          <v-row >
            <v-col
              v-for="(file, i) in files"
              :key="i"
              cols="12"
              md="4"
              height="500px"
            >
            <v-spacer ></v-spacer>
              <v-card
                class="py-6 px-4"
                color="grey lighten-5"
                elevation="3"
                flat
                height="100%"

         
              >
                <v-theme-provider >
                  <div>

                  <v-avatar
                      color="#AD8744"
                      size="88"
                      
                    >
                      <v-icon
                        large
                        color="white"
                        
                      >mdi-file</v-icon>
                    </v-avatar>

                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="file.title"
                ></v-card-title>

                <v-card-text
                  class="subtitle-1   "
                  
                >
                {{file.text}}
                </v-card-text>
                <v-spacer ></v-spacer>
           <div class="pt-5" >
          
          <v-btn
            color="grey"
            outlined
            align="bottom"
            large
            :href="file.link"
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Download
            </span>
            <v-icon
                        large
                        color="#AD8744"
                        
                      >mdi-download</v-icon>
          </v-btn>
          </div>
              </v-card>
            </v-col>
          </v-row>
          </div>
        
      </v-card>
      </v-col>
      </v-row>
    </v-container>
    </v-content>


</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
const dataAPI = require("@/config/hosts").dataAPI;
export default {
  name: 'Home',
  components: {
    HelloWorld
  },
 data() {
    return {
    file: "",
    result: "",
    search:"",
    text:"",
    numOrg: 0,
    numData: 0,
    numLocal: 0,
    numPessoa: 0,
    numProfissao: 0,

    headers: [
          {
            text: 'Entity Type',
            align: 'start',
            sortable: true,
            value: 'entidade',
          },
          { text: 'Named Entity', value: 'nome' },
          { text: 'Probability', value: 'probabilidade' },
        ],
    files: [
            {
              title: 'IFIP',
              text: 'This dataset consists of a fond that shows a pioneering period in computing history, between 1959 and 1998. This fond (PT/UM-ADB/ASS/IFIP) was produced by the International Federation for Information Processing (IFIP).',
              link: dataAPI +"downloads/IFIP"
            },
            {
              title: 'Inquirições de Genere 1',
              text: ' This dataset corresponds to a series (PT/UM-ADB/DIO/MAB/006), from the archival fond Mitra Arquiepiscopal de Braga, which contains genre inquiries.',
              link:dataAPI +"downloads/IG"
            },
            {
              title: 'Inquirições de Genere 2',
              text: ' This dataset was extracted from a series (PT/UM-ADB/DIO/MAB/006), from the archival fond Mitra Arquiepiscopal de Braga, which contains genre inquiries.',
              link:dataAPI +"downloads/IG2"
            },
            {
              title: 'Arquivo da Casa Avelar',
              text: 'A historical dataset corresponding to the fond (PT/UM-ADB/FAM/ACA) of the Arquivo da Casa do Avelar (ACA) which depicts the family history of Jácome de Vasconcelos, knight and servant of King D. João I.',
              link:dataAPI +"downloads/ACA"
            },
            {
              title: 'Famália Araújo de Azevedo',
              text: 'The Familia Araújo de Azevedo fond (FAA), also known as Arquivo do Conde da Barca was produced from 1489 to 1879 by Araújo de Azevedo’s family.',
              link:dataAPI +"downloads/FAA"
            },
            {
              title: 'Jardim do Mar',
              text: 'This datasets corresponds to a fond from the parish Jardim do Mar (retrieved from Arquivo e Biblioteca da Madeira) that consists of three series, which represent registrations of weddings, baptisms and deaths.',
              link:dataAPI +"downloads/ABM_805"
            },
            {
              title: 'Curral das Freiras',
              text: 'This datasets corresponds to a fond from the parish Curral das Freiras (retrieved from Arquivo e Biblioteca da Madeira) that consists of three series, which represent registrations of weddings, baptisms and deaths.',
              link:dataAPI +"downloads/ABM_807"
            },
            {
              title: 'Archive Project V4',
              text: 'This dataset was used to train the ML models. It was created by merging parts of the datasets.',
              link:dataAPI +"downloads/archive_project_v4full_spacy"
            },
            {
              title: 'Arquivo Oliveira Salazar',
              text: 'The Archive of Oliveira Salazar, retrieved from Arquivo da Torre do Tombo.',
              link:dataAPI +"downloads/AOS.bio"
            }
          ],
    }
  },

};
</script>
}
</script>
